import React, { useEffect } from 'react';
import {
  GOOGLE_ADS_SCRIPT_URL,
  GOOGLE_IMA_SCRIPT_URL,
  SHAKA_PLAYER_SCRIPT_URL,
  TAG_MANAGER_SCRIP_URL,
} from './utils/constants';

export const useMountedInitialScripts = () => {
  const mountedScripts = url => {
    const script = document.createElement('script');
    script.src = url;
    document.body.appendChild(script);
    script.onload = () => {
      
    };
  };
  useEffect(() => {
    try {
      mountedScripts(TAG_MANAGER_SCRIP_URL);
      mountedScripts(GOOGLE_ADS_SCRIPT_URL);
      mountedScripts(GOOGLE_IMA_SCRIPT_URL);
      mountedScripts(SHAKA_PLAYER_SCRIPT_URL);
    } catch (error) {}
  }, []);
};
